require("../../node_modules/masonry-layout/dist/masonry.pkgd");

module.exports = {
  init: () => {
    $(".masonry").masonry({
      itemSelector: ".masonry-item"
    });
  }
};
